module.exports = __webpack_public_path__ + "img/report.2ecfeb7f.png";